export enum ExceptionalAttributes {
  DT_SINAL_VITAL = 'DT_SINAL_VITAL',
  IE_PERIODO_RETROATIVO = 'IE_PERIODO_RETROATIVO',
  NM_PROFESSIONAL = 'NM_PROFESSIONAL',
  NR_SINAL_VITAL = 'NR_SINAL_VITAL',
  DATE_TIME = 'DATE_TIME'
}
